import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaContent from './VaContent.vue'

export default withConfigTransport(VaContent)
